




























import { Component, Vue, Prop } from 'vue-property-decorator';
import 'animate.css';

@Component({
  name: 'MarketDataCard',
})
export default class MarketDataCard extends Vue {
  @Prop(Boolean) public loaded!: boolean;
  @Prop(String) public color!: string;
}
